import { DateTime } from "luxon";

import { getLastDayOfMonthByDateByMM_YYYY } from "../utils/dateUtils";

const NUMBER_OF_DATA_DELAY_DAYS = 3;

/**
 * Choose the date to fetch a currency conversion rate for a given month:
 *
 * - **Historical months**: we use the true last day of the month,
 *   since those rates are finalized and available.
 * - **Current month**: because the dashboard data can lag by ~NUMBER_OF_DATA_DELAY_DAYS days,
 *   we pick the date NUMBER_OF_DATA_DELAY_DAYS days ago (at UTC midnight)
 *   to ensure the rate is actually present.
 *
 * @param monthYear – A string in `"MM_YYYY"` format identifying the target month.
 * @returns A `Date` at UTC midnight for the chosen conversion‐rate date.
 */
export const getLastDayOfMonthForCurrencyConversionRate = (monthYear: string): Date => {
  const [MM, YYYY] = monthYear.split("_").map(Number);
  const nowUtc = DateTime.utc();

  if (MM === nowUtc.month && YYYY === nowUtc.year) {
    // Use the most recent date for which we expect data to exist:
    return nowUtc.minus({ days: NUMBER_OF_DATA_DELAY_DAYS }).startOf("day").toJSDate();
  }

  // For past months, use the definitive month‐end date:
  return getLastDayOfMonthByDateByMM_YYYY(monthYear);
};
